import axios from 'axios';
import { HOST } from 'config/config';
import { MessageTypeEnumValue } from 'enums/MessageTypeEnum';
import reportError from 'services/ErrorHandler/ErrorHandler';
import { createPatchDocument } from 'services/Serializers/PatchDocument';
import { SHOW_MESSAGE } from 'redux/Message/MessageType';
import {
  ACTIVATE_ACCOUNT_PENDING,
  ACTIVATE_ACCOUNT,
  ACTIVATE_ACCOUNT_ERROR,
  LOGIN_FULFILLED,
  LOGIN_PENDING,
  LOGIN_REJECTED,
  LOGOUT,
  GET_PROFILE_PENDING,
  GET_PROFILE_FULFILLED,
  PERSISTED_EMAIL_CONFIRMATION,
  PERSISTED_EMAIL_CONFIRMATION_REJECTED,
  PERSISTED_PASSWORD,
  PERSISTED_PASSWORDRESET,
  PERSISTED_PASSWORDRESET_REJECTED,
  PERSISTED_PROFILE,
  PERSISTED_REGISTERVIEWMODEL,
  PERSISTING_EMAIL_CONFIRMATION,
  PERSISTING_PASSWORDRESET,
  PERSISTING_PROFILE,
  PERSISTING_REGISTERVIEWMODEL,
  PERSIST_PASSWORD_REJECTED,
  PERSIST_REGISTERVIEWMODEL_REJECTED,
  SENDING_EMAIL_CONFIRMATION_EMAIL,
  SENDING_PASSWORD_RECOVERY,
  SENT_EMAIL_CONFIRMATION_EMAIL,
  SENT_EMAIL_CONFIRMATION_REJECTED,
  SENT_PASSWORD_RECOVERY,
  SENT_PASSWORD_RECOVERY_REJECTED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_RECOVERY,
  UPDATE_PASSWORD_RESET,
  UPDATE_PROFILE,
  UPDATE_REGISTERVIEWMODEL,
  RESET_ACCOUNT_ERRORS,
  UPDATE_LANGUAGE,
  SHOW_ADDRESS_EDIT_MODAL,
  HIDE_ADDRESS_EDIT_MODAL,
  PERSIST_PROFILE_ADDRESS_PENDING,
  PERSIST_PROFILE_ADDRESS_FULFILLED,
  PERSIST_PROFILE_ADDRESS_REJECTED,
  CREATE_PROFILE_ADDRESS_PENDING,
  CREATE_PROFILE_ADDRESS_FULFILLED,
  CREATE_PROFILE_ADDRESS_REJECTED,
} from './AccountType';

export function getProfile() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.gettingProfile) {
        return dispatch({
          type: GET_PROFILE_PENDING,
          payload: axios
            .get(`${HOST}/dealer/authentication/account/profile`)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: GET_PROFILE_FULFILLED,
                payload: {
                  profile: json,
                },
              });

              return resolve(json);
            })
            .catch(error => reportError(error, dispatch)),
        });
      }
    });
  };
}

export function loginWithSaml2Token(bearerToken) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (
        !getState().AccountReducer.isLoggedIn &&
        !getState().AccountReducer.isLoggingIn &&
        !getState().AccountReducer.attemptedLoginWithCookie
      ) {
        return dispatch({
          type: LOGIN_PENDING,
          payload: axios
            .get(`${HOST}/dealer/authentication/account/saml2/token`, {
              headers: {
                Authorization: `bearer ${bearerToken}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: LOGIN_FULFILLED,
                payload: json,
              });

              return resolve(json);
            })
            .catch(error => {
              dispatch({
                type: LOGIN_REJECTED,
                payload: error,
              });

              return reject(error);
            }),
        });
      }

      return reject();
    });
  };
}

export function login(username, password, rememberMe) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.isLoggingIn) {
        var data = {
          username: username,
          password: password,
          grant_type: 'password',
        };

        return dispatch({
          type: LOGIN_PENDING,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/authenticate`, data)
            .then(response => response.data)
            .then(json => {
              axios
                .get(`${HOST}/dealer/authentication/account/token?accessToken=${json.token}`, {
                  headers: {
                    Authorization: `bearer ${json.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },
                })
                .then(response => response.data)
                .then(bearerJson => {
                  dispatch({
                    type: LOGIN_FULFILLED,
                    payload: { ...bearerJson, rememberMe },
                  });

                  return resolve(bearerJson);
                });
            })
            .catch(error =>
              dispatch({
                type: LOGIN_REJECTED,
                payload: error,
              }),
            ),
        });
      }
    });
  };
}

export function logout() {
  return (dispatch, getState) => {
    if (getState().AccountReducer.isLoggedIn) {
      return dispatch({
        type: LOGOUT,
      });
    }
  };
}

export function loginWithCookie(access_token, force = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (
        force ||
        (!getState().AccountReducer.isLoggedIn &&
          !getState().AccountReducer.isLoggingIn &&
          !getState().AccountReducer.attemptedLoginWithCookie)
      ) {
        return dispatch({
          type: LOGIN_PENDING,
          payload: axios
            .get(`${HOST}/dealer/authentication/account/token?accessToken=${access_token}`, {
              headers: {
                Authorization: `bearer ${access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: LOGIN_FULFILLED,
                payload: json,
              });

              return resolve(json);
            })
            .catch(error => {
              dispatch({
                type: LOGIN_REJECTED,
                payload: error,
              });

              return reject(error);
            }),
        });
      }

      return reject();
    });
  };
}

export function updateProfile(profile) {
  return dispatch =>
    dispatch({
      type: UPDATE_PROFILE,
      payload: profile,
    });
}

export function persistProfile(profile) {
  return (dispatch, getState) => {
    if (!getState().AccountReducer.updating) {
      return dispatch({
        type: PERSISTING_PROFILE,
        payload: axios
          .put(`${HOST}/dealer/authentication/account`, profile)
          .then(response => response.data)
          .then(json => {
            dispatch({
              type: PERSISTED_PROFILE,
              payload: profile,
            });

            dispatch({
              type: SHOW_MESSAGE,
              payload: {
                type: MessageTypeEnumValue.Success,
                titleKey: 'success',
                messageKey: 'saved_successfully',
              },
            });
          })
          .catch(error => {
            dispatch({
              type: SHOW_MESSAGE,
              payload: {
                type: MessageTypeEnumValue.Danger,
                titleKey: 'error',
                message: error.response,
              },
            });
            return reportError(error, dispatch);
          }),
      });
    }
  };
}

export function patchProfile(profileUpdateModel) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patch = createPatchDocument(profileUpdateModel.fieldValues);

      return dispatch({
        type: PERSISTING_PROFILE,
        payload: axios
          .patch(`${HOST}/dealer/authentication/account`, patch)
          .then(response => response.data)
          .then(json => {
            dispatch({
              type: PERSISTED_PROFILE,
              payload: json,
            });

            dispatch({
              type: SHOW_MESSAGE,
              payload: {
                type: MessageTypeEnumValue.Success,
                messageKey: 'saved_successfully',
              },
            });

            return resolve(json);
          })
          .catch(error => reportError(error, dispatch)),
      });
    });
  };
}

export function updatePassword(passwordViewModel) {
  return dispatch =>
    dispatch({
      type: UPDATE_PASSWORD,
      payload: passwordViewModel,
    });
}

export function persistPassword(passwordViewModel) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.updating) {
        return dispatch({
          type: PERSISTING_PROFILE,
          payload: axios
            .put(`${HOST}/dealer/authentication/account/update-password`, passwordViewModel)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: PERSISTED_PASSWORD,
                payload: passwordViewModel,
              });

              dispatch({
                type: SHOW_MESSAGE,
                payload: {
                  type: MessageTypeEnumValue.Success,
                  titleKey: 'success',
                  messageKey: 'password_updated_successfully',
                },
              });

              resolve();
            })
            .catch(error => {
              dispatch({
                type: PERSIST_PASSWORD_REJECTED,
                payload: error.response.data.messages,
              });
              return reportError(error, dispatch);
            }),
        });
      }
    });
  };
}

export function updateRegisterViewModel(registerViewModel) {
  return dispatch =>
    dispatch({
      type: UPDATE_REGISTERVIEWMODEL,
      payload: registerViewModel,
    });
}

export function register(registerViewModel) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.persistingRegisterViewModel) {
        return dispatch({
          type: PERSISTING_REGISTERVIEWMODEL,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/register`, registerViewModel)
            .then(response => response.data)
            .then(json => {
              if (!json.success) {
                dispatch({
                  type: PERSIST_REGISTERVIEWMODEL_REJECTED,
                  payload: json.messages,
                });
              } else {
                dispatch({
                  type: PERSISTED_REGISTERVIEWMODEL,
                  payload: registerViewModel,
                });

                dispatch({
                  type: SHOW_MESSAGE,
                  payload: {
                    type: MessageTypeEnumValue.Success,
                    titleKey: 'success',
                    messageKey: 'saved_successfully',
                  },
                });

                return resolve(json);
              }
            }),
        });
      }
    });
  };
}

export function updatePasswordRecoveryViewModel(passwordRecoveryViewModel) {
  return dispatch =>
    dispatch({
      type: UPDATE_PASSWORD_RECOVERY,
      payload: passwordRecoveryViewModel,
    });
}

export function sendPasswordRecoveryLink(passwordRecoveryViewModel) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.sendingPasswordRecovery) {
        dispatch({
          type: SENDING_PASSWORD_RECOVERY,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/password-recovery`, passwordRecoveryViewModel, {
              headers: {
                'Accept-Language': getState().AccountReducer.languageCode,
              },
            })
            .then(response => response.data)
            .then(json => {
              if (!json.success) {
                dispatch({
                  type: SENT_PASSWORD_RECOVERY_REJECTED,
                  payload: json.messages,
                });
              } else {
                dispatch({
                  type: SENT_PASSWORD_RECOVERY,
                });
              }

              return resolve();
            }),
        });
      }
    });
  };
}

export function updatePasswordResetViewModel(passwordResetViewModel) {
  return dispatch =>
    dispatch({
      type: UPDATE_PASSWORD_RESET,
      payload: passwordResetViewModel,
    });
}

export function persistPasswordReset(passwordResetViewModel) {
  return (dispatch, getState) => {
    if (!getState().AccountReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: PERSISTING_PASSWORDRESET,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/password-reset`, passwordResetViewModel)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: PERSISTED_PASSWORDRESET,
              });

              return resolve();
            })
            .catch(error => {
              dispatch({
                type: PERSISTED_PASSWORDRESET_REJECTED,
                payload: error.response.data.messages,
              });
              reportError(error, dispatch);
              return reject();
            }),
        }),
      );
    }
  };
}

export function sendEmailConfirmationEmail(username) {
  return (dispatch, getState) => {
    if (!getState().AccountReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: SENDING_EMAIL_CONFIRMATION_EMAIL,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/send-email-confirmation`, {
              username: username,
            })
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: SENT_EMAIL_CONFIRMATION_EMAIL,
              });

              return resolve();
            })
            .catch(error => {
              dispatch({
                type: SENT_EMAIL_CONFIRMATION_REJECTED,
                payload: error.response.data.messages,
              });
              reportError(error, dispatch);
              return reject();
            }),
        }),
      );
    }
  };
}

export function persistConfirmEmail(emailConfirmationViewModel) {
  return (dispatch, getState) => {
    if (!getState().AccountReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: PERSISTING_EMAIL_CONFIRMATION,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/email-confirmation`, emailConfirmationViewModel)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: PERSISTED_EMAIL_CONFIRMATION,
              });

              return resolve();
            })
            .catch(error => {
              dispatch({
                type: PERSISTED_EMAIL_CONFIRMATION_REJECTED,
                payload: error.response.data.messages,
              });
              reportError(error, dispatch);
              return reject();
            }),
        }),
      );
    }
  };
}

export function resetAccountErrors() {
  return dispatch =>
    dispatch({
      type: RESET_ACCOUNT_ERRORS,
    });
}

export function updateLanguage(languageCode) {
  return dispatch =>
    dispatch({
      type: UPDATE_LANGUAGE,
      payload: languageCode,
    });
}

export function activateAccount(activationModel) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      if (!getState().AccountReducer.activatingAccount) {
        return dispatch({
          type: ACTIVATE_ACCOUNT_PENDING,
          payload: axios
            .post(`${HOST}/dealer/authentication/account/activate-user`, activationModel)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: ACTIVATE_ACCOUNT,
              });
              return resolve(json);
            })
            .catch(error => {
              dispatch({
                type: ACTIVATE_ACCOUNT_ERROR,
                payload: error.response.data.messages,
              });
              reportError(error, dispatch);
            }),
        });
      }
    });
}

export function showEditAddressModal() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SHOW_ADDRESS_EDIT_MODAL,
      });
      return resolve();
    });
  };
}

export function hideEditAddressModal() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: HIDE_ADDRESS_EDIT_MODAL,
      });
      return resolve();
    });
  };
}

export function patchProfileAddress(profileAddressUpdateModel) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.patchingProfileAddress) {
        let patch = createPatchDocument(profileAddressUpdateModel.fieldValues);
        return dispatch({
          type: PERSIST_PROFILE_ADDRESS_PENDING,
          payload: axios
            .patch(`${HOST}/api/portal/profiles/address/${profileAddressUpdateModel.address.id}`, patch)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: PERSIST_PROFILE_ADDRESS_FULFILLED,
                payload: { address: json },
              });

              dispatch({
                type: SHOW_MESSAGE,
                payload: {
                  type: MessageTypeEnumValue.Success,
                  messageKey: 'saved_successfully',
                },
              });

              return resolve(json);
            })
            .catch(error => {
              dispatch({
                type: PERSIST_PROFILE_ADDRESS_REJECTED,
              });
              reportError(error, dispatch);
            }),
        });
      }
    });
  };
}

export function createProfileAddress(address) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!getState().AccountReducer.patchingProfileAddress) {
        return dispatch({
          type: CREATE_PROFILE_ADDRESS_PENDING,
          payload: axios
            .post(`${HOST}/api/portal/profiles/address`, address)
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: CREATE_PROFILE_ADDRESS_FULFILLED,
                payload: { address: json },
              });

              dispatch({
                type: SHOW_MESSAGE,
                payload: {
                  type: MessageTypeEnumValue.Success,
                  messageKey: 'saved_successfully',
                },
              });

              return resolve(json);
            })
            .catch(error => {
              dispatch({
                type: CREATE_PROFILE_ADDRESS_REJECTED,
              });
              reportError(error, dispatch);
            }),
        });
      }
    });
  };
}
